import { perPage } from '../constants/general.constant';
export interface PaginatedResponse<T> {
    data: Array<T>;
    meta: {
        path: string;
        total?: number;
        current_page: number;
        last_page?: number;
        per_page: number;
        from: number;
        to: number;
        city?: any;
    };
    links: {
        first: string;
        prev: string | null;
        next: string | null;
        last?: string;
    };
    current_page?: number;
    last_page?: number;
}

export class ListingParamsModel {
    search?: string;
    key?: string;
    page?: number;
    other?: string;
    direction?: string;
    user_id?: number;
    statuses?: Array<string>;
    type?: string;
    per_page?: number = perPage;
    relation?: string;
}

export type OptionallyPaginatedResponse<T> = PaginatedResponse<T> | Array<T>;
